import React from 'react';
import * as RadixPopover from '@radix-ui/react-popover';
import classNames from 'classnames';
import { keyframes } from 'glamor';

import { createStyles } from 'utils/createStyle';
import { colors } from 'styles/settings';
import { ModalStyles } from 'styles/modals';
import { EASE_OUT_QUART } from 'styles/easing';

const slideDownOpen = keyframes({
    '0%': { opacity: 0, transform: 'translateY(-10px)' },
    '100%': { opacity: 1, transform: 'translateY(0)' },
});

const slideUpOpen = keyframes({
    '0%': { opacity: 0, transform: 'translateY(10px)' },
    '100%': { opacity: 1, transform: 'translateY(0)' },
});

const slideDownClosed = keyframes({
    '0%': { opacity: 1, transform: 'translateY(0)' },
    '100%': { opacity: 0, transform: 'translateY(10px)' },
});

const slideUpClosed = keyframes({
    '0%': { opacity: 1, transform: 'translateY(0)' },
    '100%': { opacity: 0, transform: 'translateY(-10px)' },
});

const styles = createStyles({
    close: `${ModalStyles.closeButton} text-brand float-right`,
    content: [
        'rounded-xl bg-white p-4 max-w-xs sm:max-w-sm',
        {
            boxShadow: '0 4px 15px rgba(0, 0, 0, 0.25)',
            animationDuration: '150ms',
            animationTimingFunction: EASE_OUT_QUART,
            '&[data-side="top"]': { animationName: slideUpOpen },
            '&[data-side="top"][data-state="closed"]': { animationName: slideDownClosed },
            '&[data-side="bottom"]': { animationName: slideDownOpen },
            '&[data-side="bottom"][data-state="closed"]': { animationName: slideUpClosed },
        },
    ],
    arrow: { fill: colors.white, marginTop: -1 },
});

export const Root = RadixPopover.Root;
export const Trigger = RadixPopover.Trigger;
export const Close = RadixPopover.Close;

export const Content = (props: React.ComponentProps<typeof RadixPopover.Content>) => {
    return (
        <RadixPopover.Portal>
            <RadixPopover.Content
                {...props}
                className={classNames(props.className, styles.content)}
            >
                <RadixPopover.Arrow width={16} height={8} className={styles.arrow} />
                {props.children}
            </RadixPopover.Content>
        </RadixPopover.Portal>
    );
};
